import { VesselData } from "../user-models/vessel-data.model";

export class Logbook {

  gearName: string = '';

  logbookID: string = '';

  vessel: VesselData = new VesselData(); // associated vessel

  isChecked: boolean = false;

  isRegistered: boolean;

  seasonYear: number = 2025; // used for mass logbook deactivation

  isActive: boolean = true; // determines if logbook is active or deactivated

  constructor(gearName: string = '', id: string = '', vessel: VesselData = new VesselData(), seasonYear: number = 2025, checked: boolean = false, registered: boolean = false, isActive: boolean = true) {
    this.gearName = gearName;
    this.logbookID = id;
    this.vessel = vessel;
    this.seasonYear = seasonYear;
    this.isChecked = checked;
    this.isRegistered = registered;
    this.isActive = isActive;
  }

  public toString(): string {
    return this.gearName + ' (#' + this.logbookID + ')';
  }

  public isValid(): boolean {
    return !!this.gearName && !!this.logbookID;
  }

  public isEqual(inputLogbook: Logbook): boolean {
     return inputLogbook.logbookID === this.logbookID;
  }

  // transform anonymous data to logbook object
  public static transformAnonymous(logbook: any): Logbook {

    if (!logbook) {
      return new Logbook();
    }

    return new Logbook(
      logbook.gearName ?? '',
      logbook.logbookID ?? '',
      VesselData.transformAnonymous(logbook.vessel),
      logbook.seasonYear ?? 2025,
      logbook.isChecked ?? false,
      logbook.isRegistered ?? false,
      logbook.isActive ?? true
    );

  }

  // check if user logbooks are defined
  public static transformAnonArray(logbooks: any): Logbook[] {

    // if logbooks do not exist, set the default ones
    if (!logbooks) {
      return [];
    }

    let userLogbooks: Logbook[] = [];
    for (let logbook of logbooks) {
      userLogbooks.push(Logbook.transformAnonymous(logbook));
    }
    return userLogbooks;

  }

}
